import { render } from "./MessageType.vue?vue&type=template&id=5caeec06&scoped=true"
import script from "./MessageType.vue?vue&type=script&lang=js"
export * from "./MessageType.vue?vue&type=script&lang=js"

import "./MessageType.vue?vue&type=style&index=0&id=5caeec06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caeec06"]])

export default __exports__